export default "__VITE_ASSET__6a70627a__"